import { create } from "zustand";
import { io } from "socket.io-client";
import authorization from "../../../utils/authorization";

const getSocketOrigin = () =>
  (
    process.env.REACT_APP_CHAT_URL ||
    process.env.REACT_APP_BASE_URL ||
    ""
  ).replace(/\/+$/, "");

export const useAuthStore = create((set, get) => ({
  onlineUsers: [],
  socket: null,
  connectionError: null,

  connectSocket: () => {
    const existingSocket = get().socket;
    if (existingSocket?.connected) return existingSocket;

    const origin = getSocketOrigin();
    const token = authorization.getAccessToken();
    if (!origin || !token) {
      set({
        connectionError: !origin
          ? "Chat service URL is not configured"
          : "Sign in to connect to chat",
      });
      return null;
    }

    existingSocket?.removeAllListeners();
    existingSocket?.disconnect();

    const socket = io(`${origin}/ws`, {
      auth: { token: `Bearer ${token}` },
    });

    set({ socket, connectionError: null });

    socket.on("connect", () => {
      set({ connectionError: null });
    });

    socket.on("connect_error", (error) => {
      set({ connectionError: error.message || "Unable to connect to chat" });
    });

    socket.on("authorization_error", (error) => {
      set({
        connectionError: error?.message || "Chat authorization failed",
      });
    });

    socket.on("activeUsers", (users = []) => {
      const userIds = users
        .map((user) => Number(typeof user === "object" ? user.id : user))
        .filter((id) => Number.isSafeInteger(id) && id > 0);
      set({ onlineUsers: userIds });
    });

    socket.on("disconnect", () => set({ onlineUsers: [] }));
    return socket;
  },

  disconnectSocket: () => {
    const socket = get().socket;
    socket?.removeAllListeners();
    socket?.disconnect();
    set({ socket: null, onlineUsers: [], connectionError: null });
  },
}));
